<template>
  <div>
    <page-header
      title="Booking Summary"
      breadcrumb="Dashboard > Booking & Shipments > Booking Summary"
      :back="-1"
    />
    <div class="booking-form__review custom-card" id="printable">
      <div class="header">
        <p>Booking Summary</p>
      </div>
      <div class="booking-summary__head">
        <div class="shipping-reference">
          <p class="shipping-detail-title">
            <span
              ><img
                src="@/assets/images/booking-management/svgs/order-number.svg"
                alt="" /></span
            >SHIPPING REFERENCE
          </p>
          <!-- <p class="shipping-detail">{{ booking.shippingReference ?  booking.shippingReference : "N/A" }}</p> -->
        </div>
        <div class="date-created">
          <p class="shipping-detail-title">
            <span
              ><img
                src="@/assets/images/booking-management/svgs/calendar.svg"
                alt="" /></span
            >DATE CREATED
          </p>
          <p class="shipping-detail">
            {{
              booking.createdAt
                ? new Date(booking.createdAt || "").toLocaleDateString()
                : "N/A"
            }}
          </p>
        </div>
        <div class="order-status">
          <p>{{ booking.deliveryStatus ? booking.deliveryStatus : "N/A" }}</p>
        </div>
        <div
          class="modify-order"
          @click="
            $router.push({
              name: 'BookingEdit',
              params: { bookingId: booking.id },
            })
          "
        >
          <p class="">
            <span class="pr-2">
              <img
                src="@/assets/images/booking-management/svgs/edit.svg"
                alt=""
              />
            </span>
            MODIFY
          </p>
        </div>
        <div class="print-summary" @click="printElement">
          <p class="">
            <span class="pr-2">
              <img
                src="@/assets/images/booking-management/svgs/print.svg"
                alt=""
              />
            </span>
            PRINT
          </p>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <div class="d-flex gap-4">
              <div>
                <img
                  src="@/assets/images/settings/dummy-user-img.png"
                  alt="user image"
                  class="user-img img-fluid"
                />
              </div>
              <div class="shipper-details">
                <p>
                  {{
                    booking.shipperlocation
                      ? booking.shipperlocation.contactName
                      : "N/A"
                  }}
                </p>
                <small>{{
                  booking.shipperlocation
                    ? booking.shipperlocation.email
                    : "˜N/A"
                }}</small>
                <br />
                <small>{{
                  booking.shipperlocation
                    ? booking.shipperlocation.mobile
                    : "N/A"
                }}</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="pickup-details">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/location.svg"
                    alt="" /></span
                >PICK-UP LOCATION
              </p>
              <p class="shipping-detail">
                {{
                  formatAddress(
                    booking.shipperlocation
                      ? booking.shipperlocation.address
                      : ""
                  )
                }},
                {{
                  booking.shipperlocation
                    ? booking.shipperlocation.city
                    : "N/A"
                }},
                {{
                  booking.shipperlocation
                    ? booking.shipperlocation.country
                    : "N/A"
                }}
              </p>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/location.svg"
                  alt="" /></span
              >RECEIVER
            </p>
            <p class="shipping-detail">
              {{
                booking.consigneelocation
                  ? booking.consigneelocation.contactName
                  : "N/A"
              }}
            </p>
            <p class="shipping-detail">
              {{
                formatAddress(
                  booking.consigneelocation
                    ? booking.consigneelocation.address
                    : "N/A"
                )
              }},
              {{
                booking.consigneelocation
                  ? booking.consigneelocation.city
                  : "N/A"
              }},
              {{
                booking.consigneelocation
                  ? booking.consigneelocation.country
                  : "N/A"
              }}
            </p>
            <p class="shipping-detail">
              {{
                booking.consigneelocation
                  ? booking.consigneelocation.email
                  : "N/A"
              }}
            </p>
          </div>
        </div>
      </div>
      <hr />

      <div class="container-fluid shipping-details">
        <div class="row">
          <div class="col-12">
            <p>Shipment Details</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/port-of-origin.svg"
                  alt="" /></span
              >PORT OF ORIGIN
            </p>
            <p class="shipping-detail">
              {{
                booking.shippingMethod == "terminal-to-terminal"
                  ? getLocationDetails(shipment.pickUp) != null
                    ? getLocationDetails(shipment.pickUp).locationName
                    : "N/A"
                  : booking.shippingMethod == "terminal-to-door" ? 
                  shipment.consigneelocation.address.name : 'N/A'

              }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/specified-shipment.svg"
                  alt="" /></span
              >SPECIFIED SHIPMENT
            </p>
            <p class="shipping-detail">
              {{ specifiedShipment ? capitalize(specifiedShipment) : "N/A" }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/shipping-mode.svg"
                  alt="" /></span
              >SHIPPING MODE
            </p>
            <p class="shipping-detail">
              {{ booking.shippingMethod ? booking.shippingMethod : "N/A" }}
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 right">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/package-type.svg"
                  alt="" /></span
              >PACKAGE TYPE
            </p>
            <p class="shipping-detail">{{ packageType }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/port-of-destination.svg"
                  alt="" /></span
              >PORT OF DESTINATION
            </p>
            <p class="shipping-detail">
              {{
                booking.shippingMethod == "terminal-to-terminal"
                  ? getLocationDetails(shipment.dropOff) != null
                    ? getLocationDetails(shipment.dropOff).locationName
                    : "N/A"
                  : booking.shippingMethod == "terminal-to-door" ? 
                  getLocationDetails(shipment.dropOff).locationName : 'N/A'
              }}
              
            </p>
          </div>
          <div class="col-12 col-md-6 col-lg-3 center">
            <p class="shipping-detail-title">
              <span
                ><img
                  src="@/assets/images/booking-management/svgs/booking-channel.svg"
                  alt="" /></span
              >BOOKING CHANNEL
            </p>
            <p class="shipping-detail">MuleEx</p>
          </div>
          <div class="shipping-reference mt-3 mb-5">
            <p class="shipping-detail-title">
              <span>
                <img
                  src="@/assets/images/booking-management/svgs/order-number.svg"
                  alt=""
                />
              </span>
              SHIPPING REFERENCE
            </p>
            <p class="shipping-detail">
              {{
                booking.shippingservice && booking.shippingservice.distance
                  ? booking.distance + " km"
                  : "N/A"
              }}
            </p>
          </div>
          <div class="container-fluid">
            <div class="row align-items-center justify-around">
              <div class="col-12 col-md-4 col-lg-4">
                <div
                  class="d-flex my-auto text-light p-2 rounded"
                  style="background: #10233e; min-height: 129px"
                >
                  <div>
                    <img
                      src="@/assets/images/icons/default-profile-image.svg"
                      alt="user image"
                      class="user-img img-fluid"
                    />
                  </div>
                  <div class="shipper-details">
                    <p>{{ shipper.contactName }}</p>
                    <small>{{ shipper.email }}</small> <br />
                    <small>{{ shipper.mobile }}</small>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4">
                <div
                  class="pickup-details p-2 rounded"
                  style="background: #10233e; color: white; min-height: 129px"
                >
                  <p class="shipping-detail-title text-light">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/location.svg"
                        alt="" /></span
                    >PICK-UP LOCATION
                  </p>
                  <p class="shipping-detail text-light">
                    {{
                      `${formatAddress(shipper.address)}
                     
                      ${shipper.city == null ? "" : shipper.city}
                    
                      ${shipper.country == null ? "" : shipper.country}`
                    }}
                  </p>
                </div>
              </div>
              <div class="col-12 col-md-4 col-lg-4">
                <div
                  class="p-2 rounded"
                  style="background: #10233e; min-height: 129px"
                >
                  <p class="shipping-detail-title text-light">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/location.svg"
                        alt="" /></span
                    >RECEIVER
                  </p>
                  <p class="shipping-detail text-light">
                    {{ consignee.contactName }},
                  </p>
                  <p class="shipping-detail text-light">
                    {{ consignee.address.name }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3">
              <p class="shipping-detail-title">
                <span
                  ><img
                    src="@/assets/images/booking-management/svgs/number-of-packages.svg"
                    alt="" /></span
                >NUMBER OF PACKAGES
              </p>
              <!-- <p class="shipping-detail">{{ packageInformation.quantity }}</p> -->
            </div>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-3">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/port-of-origin.svg"
                      alt="" /></span
                  >ORIGIN
                </p>
                <p class="shipping-detail">
                  {{
                    shipment.shippingMethod == 'terminal-to-terminal'
                      ? getLocationDetails(shipment.shippingservice.takeOffLocation).locationName
                      : shipment.shippingMethod == 'terminal-to-door' ?
                      shipment.consigneelocation.address.name : 'N/A'
                  }}
                </p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 center">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/specified-shipment.svg"
                      alt="" /></span
                  >SPECIFIED SHIPMENT
                </p>
                <p class="shipping-detail">
                  {{
                    packageInformation[0].shipmentType
                      ? packageInformation[0].shipmentType
                      : "Package"
                  }}
                </p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 center">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/shipping-mode.svg"
                      alt="" /></span
                  >SHIPPING MODE
                </p>
                <p class="shipping-detail">
                  {{
                    shipment.shippingMethod ? shipment.shippingMethod : "N/A"
                  }}
                </p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 right">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/package-type.svg"
                      alt="" /></span
                  >PACKAGE TYPE
                </p>
                <p class="shipping-detail">
                  {{
                    shipment.packagees
                      ? shipment.packagees[0].shipmentType
                      : "--"
                  }}
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-3">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/port-of-destination.svg"
                      alt="" /></span
                  >DESTINATION
                </p>
                <p class="shipping-detail">
                  {{
                    shipment.shippingMethod == 'terminal-to-terminal'
                      ? shipment.shippingservice ? shipment.shippingservice.arrivalLocation : 'N/A'
                      : shipment.shippingMethod == 'terminal-to-door' ? getLocationDetails(shipment.dropOff).locationName : 'N/A'
                  }}
                </p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 center">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/booking-channel.svg"
                      alt="" /></span
                  >BOOKING CHANNEL
                </p>
                <p class="shipping-detail">MULEEX</p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 center">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/shipping-option.svg"
                      alt="" /></span
                  >SHIPPING OPTION
                </p>
                <p class="shipping-detail">
                  {{
                    paymentInformation.orgName
                      ? paymentInformation.orgName
                      : "Express (Air)"
                  }}
                </p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 right">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/channel-waybill.svg"
                      alt="" /></span
                  >WAYBILL NO
                </p>
                <p class="shipping-detail">SC02099X</p>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 col-lg-3">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/channel-waybill.svg"
                      alt="" /></span
                  >PACKAGE DESCRIPTION
                </p>
                <p class="shipping-detail">
                  {{ packageInformation[0].description }}
                </p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 center">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/route.svg"
                      alt="" /></span
                  >ROUTE
                </p>
                <p class="shipping-detail">
                  {{ formatAddress(shipper.address) }} -
                  {{ formatAddress(consignee.address) }}
                </p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 center">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/distance.svg"
                      alt="" /></span
                  >DISTANCE
                </p>
                <p class="shipping-detail">{{ shipment.distance }}</p>
              </div>
              <div
                class="col-12 col-md-6 col-lg-3 right cursor-pointer"
                @click="openRouteInfo"
              >
                <p class="shipping-detail-title">
                  <u>View detailed route info</u>
                </p>
              </div>
            </div>
          </div>

          <hr />

          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <p class="font-semibold">Package Details</p>
              </div>
            </div>
            <div
              class="row"
              v-for="(packages, index) in packageInformation"
              :key="index"
            >
              <div class="col-12 mb-3 mt-2">
                <p class="font-semibold">Package {{ index + 1 }}</p>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/number-of-packages.svg"
                      alt="" /></span
                  >NUMBER OF PACKAGES
                </p>
                <p class="shipping-detail">{{ packages.quantity }}</p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 center">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/channel-waybill.svg"
                      alt="" /></span
                  >WEIGHT
                </p>
                <p class="shipping-detail">{{ packages.estimatedWeight }}kg</p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 center">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/dimension.svg"
                      alt="" /></span
                  >DIMENSION (LxWxH)
                </p>
                <p class="shipping-detail">
                  <span v-if="packages.shipmentType != 'light'"
                    >{{ packages.length }}x{{ packages.width }}x{{
                      packages.height
                    }}
                    cm</span
                  >
                  <span v-else>N/A</span>
                </p>
              </div>
              <div class="col-12 col-md-6 col-lg-3 right">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/special-handling.svg"
                      alt="" /></span
                  >SPECIAL HANDLING
                </p>
                <p class="shipping-detail">
                  {{
                    packages.specialHandling !== ""
                      ? packages.specialHandling.join()
                      : "N/A"
                  }}
                </p>
              </div>
              <div class="col-12 mt-4 col-md-6 col-lg-3">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/declared-value.svg"
                      alt="" /></span
                  >DECLARED VALUE
                </p>
                <p class="shipping-detail">₦{{ packages.itemValue }}.00</p>
              </div>
              <div class="col-12 mt-4 col-md-6 col-lg-3">
                <p class="shipping-detail-title">
                  <span
                    ><img
                      src="@/assets/images/booking-management/svgs/channel-waybill.svg"
                      alt="" /></span
                  >PACKAGE DESCRIPTION
                </p>
                <p class="shipping-detail">{{ packages.description }}</p>
              </div>
            </div>
          </div>

          <hr />

          <div class="container-fluid payment-summary">
            <div class="row">
              <div class="col-12">
                <p class="font-semibold">Payment Summary</p>
              </div>
            </div>

            <div>
              <div class="row">
                <div class="col-12 col-md-6 col-lg-3">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/service.svg"
                        alt=""
                    /></span>
                    SERVICE
                  </p>
                  <p class="shipping-detail">
                    {{ shippingService ? shippingService.orgName : 'N/A' }}
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 center">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/net-shipping-cost.svg"
                        alt="" /></span
                    >NET SHIPPING COST
                  </p>
                  <p class="shipping-detail">
                    ₦{{
                      transaction
                        ? transaction.breakDown != undefined
                          ? JSON.parse(transaction.breakDown).netPrice
                          : "0.0"
                        : "0.00"
                    }}
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 center">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/booking-channel.svg"
                        alt="" /></span
                    >HANDLING CHARGES
                  </p>
                  <p class="shipping-detail">
                    ₦{{
                      transaction
                        ? transaction.breakDown != undefined
                          ? JSON.parse(transaction.breakDown).handlingCharges
                          : "0.0"
                        : "0.00"
                    }}
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 right">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/insurance.svg"
                        alt="" /></span
                    >INSURANCE
                  </p>
                  <p class="shipping-detail">
                    ₦{{
                      transaction
                        ? transaction.breakDown != undefined
                          ? JSON.parse(transaction.breakDown).insuranceFee
                          : "0.0"
                        : "0.00"
                    }}
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6 col-lg-3">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/booking-channel.svg"
                        alt="" /></span
                    >RETURN SHIPPING COST
                  </p>
                  <p class="shipping-detail">₦0.00</p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 center">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/stop-diversion-cost.svg"
                        alt="" /></span
                    >STOP/DIVERSION COST
                  </p>
                  <p class="shipping-detail">₦0.00</p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 center">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/total.svg"
                        alt="" /></span
                    >TOTAL
                  </p>
                  <p class="shipping-detail">
                    ₦{{ transaction ? transaction.totalValue : "0.0" }}
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 right">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/promo-code.svg"
                        alt="" /></span
                    >PROMO CODE
                  </p>
                  <p class="shipping-detail">******</p>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-md-6 col-lg-3">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/total.svg"
                        alt="" /></span
                    >DISCOUNT TOTAL
                  </p>
                  <p class="shipping-detail">₦0.00</p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 center">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/tax-vat-charges.svg"
                        alt="" /></span
                    >Tax/VAT
                  </p>
                  <p class="shipping-detail">
                    ₦{{
                      transaction
                        ? transaction.breakDown != undefined
                          ? JSON.parse(transaction.breakDown).vat
                          : "0.0"
                        : "0.00"
                    }}
                  </p>
                </div>
                <div class="col-12 col-md-6 col-lg-3 center">
                  <p class="shipping-detail-title">
                    <span
                      ><img
                        src="@/assets/images/booking-management/svgs/payment-due.svg"
                        alt="" /></span
                    >PAYMENT DUE
                  </p>
                  <p class="shipping-detail">₦0.00</p>
                </div>
              </div>
            </div>
          </div>
          <div class="my-4">
            <p class="font-normal text-sm">
              This bill excludes duties and other government charges.
            </p>
          </div>
        </div>

        <div class="button-wrapper">
          <p
            class="mt-4 cursor-pointer underline"
            @click="$emit('back-one-form')"
          >
            Back
          </p>
          <div>
            <div class="flex flex-end gap-4 items-center">
              <div
                class="d-flex hover:bg-gray-100 rounded gap-2 cursor-pointer"
                @click="generateQuote()"
              >
                <span>
                  <svg
                    v-if="!generatingQuote"
                    width="20"
                    height="18"
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 6H12V0H7.99998V6H4.99998L9.99998 11L15 6ZM19.338 12.532C19.128 12.308 17.727 10.809 17.327 10.418C17.0467 10.1493 16.6733 9.99951 16.285 10H14.528L17.592 12.994H14.048C13.9998 12.9931 13.9523 13.0049 13.9101 13.0283C13.868 13.0516 13.8328 13.0857 13.808 13.127L12.992 15H7.00798L6.19198 13.127C6.16705 13.0858 6.13178 13.0519 6.08968 13.0286C6.04758 13.0052 6.00011 12.9933 5.95198 12.994H2.40798L5.47098 10H3.71498C3.31798 10 2.93898 10.159 2.67298 10.418C2.27298 10.81 0.871981 12.309 0.661981 12.532C0.172981 13.053 -0.0960191 13.468 0.0319809 13.981L0.592981 17.055C0.720981 17.569 1.28398 17.991 1.84498 17.991H18.157C18.718 17.991 19.281 17.569 19.409 17.055L19.97 13.981C20.096 13.468 19.828 13.053 19.338 12.532Z"
                      fill="#383F51"
                    />
                  </svg>
                  <div class="loader" v-else></div>
                </span>
                <span class="text-sm"> Generate Estimate</span>
              </div>
              <button
                class="button button-long mt-2"
                @click="$emit('change-form')"
              >
                Make Payment
              </button>
            </div>
          </div>
        </div>

        <multiple-consignee-modal
          :show-modal="isMultipleConsigneeModal"
          @close-modal="isMultipleConsigneeModal = false"
          @change-form="$emit('change-form')"
          @add-new-consignee="$emit('add-new-consignee')"
        />
        <view-detailed-route-modal
          :showModal="viewDetailedRouteModal"
          :booking="bookingComputed"
          @close-modal="viewDetailedRouteModal = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import ViewDetailedRouteModal from "./NewBooking/Modals/ViewDetailedRouteModal";
import PageHeader from "@/components/UI/NewPageHeader";
import html2pdf from "html2pdf.js";

export default {
  name: "new-booking-review",
  components: {
    // ViewDetailedRouteModal,
    PageHeader,
  },
  computed: {
    shipper() {
      return this.$store.getters.shipperInformation;
    },
    consignee() {
      return this.$store.getters.consigneeInformation;
    },
    packageInformation() {
      return this.$store.getters.packageInformation;
    },
    shipInformation() {
      return this.$store.getters.shippingInformation;
    },
    shippingService() {
      return this.$store.getters.shippingService;
    },
    costType() {
      return this.$store.getters.costType;
    },
    costTypeObject() {
      if (this.costType == "Standard") {
        return this.$store.getters.costTypes.standardCost;
      } else if (this.costType == "Economy") {
        return this.$store.getters.costTypes.economyCost;
      } else if (this.costType == "Express") {
        return this.$store.getters.costTypes.expressCost;
      } else {
        return this.$store.getters.costTypes;
      }
    },

    paymentInformation() {
      let totalPaymentInformation = this.$store.getters.paymentInformation;
      return totalPaymentInformation;
    },
    packageType() {
      return this.$store.getters.packageType;
    },
    takeOffObject() {
      return this.$store.getters.takeOffTerminals.find(
        (x) => x.id == this.shippingInformation.dropOff
      );
    },
    pickUpObject() {
      return this.$store.getters.pickUpTerminals.find(
        (x) => x.id == this.shippingInformation.pickUp
      );
    },
    packagingTypes() {
      let packagingTypes = [];
      this.packages.forEach((selectedPackage) => {
        packagingTypes.push(selectedPackage.shipmentType);
      });
      return packagingTypes.join();
    },
    bookingComputed() {
      return {
        consigneelocation: this.consignee,
        shipperlocation: this.$store.getters.shipperInformation,
        shippingservice: this.shippingInformation,
        paymentInformation: this.paymentInformation,
        packagees: this.$store.getters.packages,
      };
    },
  },
  data() {
    return {
      viewDetailedRouteModal: false,
      reviewDetails: {},
      isMultipleConsigneeModal: false,
      generatingQuote: false,
      shippingInformation: "",
      packages: [{}],
      transaction: {},
      booking: "",
      shipment: {},
    };
  },
  methods: {
    printElement() {
      var $printSection = document.getElementById("printable");

      if (!$printSection) {
        $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
      }

      window.print();
    },
    async getShipping(id) {
      try {
        this.loading = true;
        await this.$_getShipmentById(id).then((response) => {
          this.booking = response.data?.data.shipping || {};
          localStorage.setItem(
            "currentShippment",
            JSON.stringify(response.data.data.shipping || {})
          );
          this.preLoadDetails(response.data.data?.shipping);
        });
        this.loading = false;

        this.$emit("close-modal", this.id);
        this.$emit("booking-subaction-completed");
      } catch (error) {
        this.loading = false;
        this.handleError(error);
      }
    },
    preLoadDetails(shipment) {
      console.log(shipment);
      this.$store.dispatch("saveBookingInformation", {
        property: "shipper",
        value: shipment?.shipperlocation,
      });

      this.$store.dispatch("saveBookingInformation", {
        property: "consignee",
        value: shipment?.consigneelocation,
      });

      this.$store.dispatch("savePackages", shipment?.packagees);

      this.$store.dispatch("saveBookingInformation", {
        property: "newPackage",
        value: shipment?.packagees,
      });

      this.transaction = shipment?.transaction;
      this.shipment = shipment;

      this.$store.dispatch("saveShippingService", shipment?.shippingservice);

      this.$store.dispatch("saveShippingId", shipment?.id);

      this.$store.dispatch("saveBookingInformation", {
        property: "shippingInformation",
        value: shipment,
      });
    },
    openRouteInfo() {
      this.viewDetailedRouteModal = true;
    },
    generateQuote() {
      try {
        this.generatingQuote = true;
        var element = document.getElementById("quoteGen");
        html2pdf(element);
        this.generatingQuote = false;
      } catch (e) {
        this.generatingQuote = false;
      }
    },
    async getReviewDetails() {
      try {
        const response = await this.$_getPaymentDetails(
          this.$store.getters.shippingId
        );
        this.reviewDetails = response.data.data.shipping;
      } catch (error) {
        this.handleError(error);
      }
    },
    splitSpecialHandlings(specialHandling) {
      let specialHandlingList = specialHandling.join();
      return specialHandlingList;
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.getShipping(this.$route.params.id);
    }
  },
};
</script>

<style lang="scss" scoped>
.booking-form__review {
  background: #ffffff;
  border-radius: 2px;
  padding: 2rem 4rem;
}

.booking-summary__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1.5rem 0 4rem 0;
}

.order-status {
  background: #fff3db;
  border-radius: 10px;
  padding: 0.25rem 1rem;
  display: flex;
  align-items: center;

  p {
    font-weight: 600;
    color: #ffa600;
  }
}

.modify-order,
.print-summary {
  color: var(--primaryblue);

  p {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-weight: 500;
  }
}

.header p {
  color: #383f51;
  font-weight: 600;
}

.row {
  padding-bottom: 1.5rem;
}

.center,
.right {
  display: flex;
  flex-direction: column;
}

.center {
  padding-left: 4rem;
  padding-right: 0;
}

.right {
  padding-left: 5rem;
}

.shipping-detail-title {
  color: #979797;
  font-size: 0.8rem;
  display: flex;
  align-items: center;

  span {
    padding-right: 0.5rem;
  }
}

.shipping-detail {
  color: #10233e;
  font-size: 0.9rem;
  font-weight: 500;
  padding-left: 1.5rem;
}

.user-img {
  width: 4rem;
  margin-right: 1rem;
}

.button {
  background-color: #fcc210;
  color: var(--primaryblue);
  border: 1px solid #fcc008;
  box-sizing: border-box;
  box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
  border-radius: 2px;
  margin-right: 1.5rem;
}

hr {
  margin: 1rem 0;
}
</style>
